export default "__VITE_ASSET__BDyT4u$s__"